var map = {
	"./animeriq-0.1.3.png": "9809",
	"./labhome1.png": "e43c",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logoBack.svg": "41e1",
	"./logoName.svg": "d02b",
	"./logoNew.png": "8400",
	"./osinthompage1.png": "17b9",
	"./others.png": "e2fe",
	"./weatherbyriq.png": "2503"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";